import { useActivityV3FindByStudent, useActivityV3FindOne } from 'src/generated/endpoint';
import { sortActivityV3 } from 'src/util/activityv3';

export function useStudentActivityV3() {
  const { data: activityv3s, isLoading, isError } = useActivityV3FindByStudent();
  const data = sortActivityV3(activityv3s);

  return {
    data,
    isLoading,
    isError,
  };
}

export function useStudentActivityV3Detail(id: number) {
  const { data, isLoading, isError, refetch } = useActivityV3FindOne(id, undefined, {
    query: {
      enabled: !!id,
    },
  });

  return {
    data,
    isLoading,
    isError,
    refetch,
  };
}
